const STORAGE_KEY = 'rbcfs.desktopNotifications.enabled'

export function isDesktopNotificationSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window
}

export function getDesktopNotificationPermission(): NotificationPermission | 'unsupported' {
  if (!isDesktopNotificationSupported()) return 'unsupported'
  return Notification.permission
}

export function isDesktopNotificationPreferenceEnabled(): boolean {
  if (typeof localStorage === 'undefined') return false
  return localStorage.getItem(STORAGE_KEY) === 'true'
}

export function setDesktopNotificationPreference(enabled: boolean): void {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false')
}

export async function requestDesktopNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (!isDesktopNotificationSupported()) return 'unsupported'
  const result = await Notification.requestPermission()
  if (result === 'granted') {
    setDesktopNotificationPreference(true)
  }
  return result
}

export interface ShowDesktopNotificationOpts {
  title: string
  body: string
  tag?: string
  onClick?: () => void
  /** When set, skip notify if document has focus and this key matches the open thread. */
  suppressKey?: string | null
  openThreadKey?: string | null
}

export function showDesktopNotification(opts: ShowDesktopNotificationOpts): void {
  if (!isDesktopNotificationSupported()) return
  if (!isDesktopNotificationPreferenceEnabled()) return
  if (Notification.permission !== 'granted') return

  if (
    typeof document !== 'undefined' &&
    document.hasFocus() &&
    opts.suppressKey &&
    opts.openThreadKey &&
    opts.suppressKey === opts.openThreadKey
  ) {
    return
  }

  // Suppress when focused and no specific suppress key (already viewing app)
  if (typeof document !== 'undefined' && document.hasFocus() && !opts.suppressKey) {
    return
  }

  try {
    const n = new Notification(opts.title, {
      body: opts.body,
      tag: opts.tag,
      renotify: Boolean(opts.tag),
    })
    if (opts.onClick) {
      n.onclick = () => {
        window.focus()
        opts.onClick?.()
        n.close()
      }
    }
  } catch {
    // Browser may block Notification constructor in some contexts
  }
}
